import { pcpGrayPalette } from "./themes/palette";

export const topToolbarStyle = {
    root: {
        flexGrow: 0,
        flexShrink: 0,
        backgroundColor: pcpGrayPalette.foreground, //color from figma
        paddingLeft: '2.75rem',    //'44px'
        paddingRight: '2.75rem',    //'44px'
        height: '3.5rem',   //56px
        //vertical align:
        display: 'flex',
        alignItems: 'center',
    },
    logo: {
        height: '1.75rem',   //'28px'
    }
}
